import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { IPredictionGroupingDto } from 'api/api';
import { InputText } from 'primereact/inputtext';
import * as React from 'react';
import { connect } from 'react-redux';
import { reactAI } from 'services/telemetry-service';
import { getPredictions } from 'state/ducks/prediction-table-settings/actions';
import { localized } from 'state/i18n';
import PredictionTable from 'view/components/table/bi-table/prediction-table';
import WhiteCard from 'view/shared/components/cards/white-card';
import { ProfileCardDoubleContainerLength } from '../administration';
import '../adminstration.scss';
import { PredictionSummary } from '../cards/predictions/prediction-summary';

type Props = {};

interface State {
	searchTerm: string;
	groupings: IPredictionGroupingDto[];
}

class MachineLearningAdministrationPage extends React.PureComponent<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			searchTerm: '',
			groupings: [],
		};
	}

	private onSearchTermChange = (event: React.FormEvent<HTMLInputElement>) => {
		const val = event.currentTarget.value;
		this.setState({ searchTerm: val });
	};

	public async componentDidMount() {
		const groupings = await getPredictions();
		this.setState({ groupings: groupings ?? [] });
	}

	public render() {
		let groupingsToDisplay: IPredictionGroupingDto[];

		if (this.state.searchTerm.length > 0) {
			groupingsToDisplay = this.state.groupings.filter(g =>
				g.serialNumber?.toLocaleLowerCase()?.includes(this.state.searchTerm.toLocaleLowerCase())
			);
		} else {
			groupingsToDisplay = this.state.groupings;
		}

		return (
			<div className="flex-direction-row flex-wrap flex-start-column">
				<div className="flex-direction-row">
					<WhiteCard
						title={localized('Predictions')}
						classNameContainer={`${ProfileCardDoubleContainerLength.classNameContainer}`}
					>
						<PredictionSummary data={groupingsToDisplay} />
					</WhiteCard>
				</div>
				<div className="flex-direction-row">
					<WhiteCard
						title={localized('Predictions')}
						classNameContainer={`${ProfileCardDoubleContainerLength.classNameContainer}`}
					>
						<span>
							<InputText
								placeholder={localized('Search')}
								value={this.state.searchTerm}
								onChange={this.onSearchTermChange}
							/>
						</span>
						<PredictionTable data={groupingsToDisplay} />
					</WhiteCard>
				</div>
			</div>
		);
	}
}

export default connect()(
	withAITracking(reactAI.reactPlugin, MachineLearningAdministrationPage, 'MachineLearningAdministrationPage')
);
